@let hasHierarchy = store.hasHierarchySg();
@let layout = store.layoutSg();
@let rowToolsOffsetLeftPx = store.rowToolsOffsetLeftPxSg();
@let rowToolsWidthPx = store.rowToolsWidthPxSg();
@let rows = store.rowsSg();
@let selection = store.selectionConfigSg();
@let wrap = store.wrapSg();

<div class="atn-ds-table-rows">
  @for (row of rows; track row.rowId) {
    <div
      class="atn-ds-table-rows__row"
      [class.atn-ds-table-rows__row--clickable]="row.onClick"
      [style]="row.styles"
      [style.grid-template-columns]="layout.gridTemplateColumns"
      (click)="rowClickHandler(row.onClick)"
    >
      @if (selection) {
        <div class="atn-ds-table-rows__cell">
          <atn-ds-checkbox
            [disabled]="row.selectionDisabled"
            [selected]="row.selected"
            (selectedChange)="selectionChangeHandler(row.rowId, $event)"
          />
        </div>
      }

      @for (cell of row.cells; track cell.columnId; let isFirst = $first) {
        <div
          class="atn-ds-table-rows__cell"
          [class.atn-ds-table-rows__cell--clickable]="cell.onClick"
          [style.text-align]="cell.align"
          (click)="cellClickHandler($event, cell.onClick)"
        >
          <div
            class="atn-ds-table-rows__content"
            [class.atn-ds-table-rows__content--wrapped]="wrap"
          >
            <div
              class="atn-ds-table-rows__cell-layout"
              [style.justify-content]="cell.justifyContent"
              [style.padding-left.px]="
                isFirst && hasHierarchy ? row.indentPx : 0
              "
            >
              @if (isFirst && hasHierarchy) {
                @if (row.hasChildren) {
                  <button
                    class="atn-ds-table-rows__hierarchy-toggle"
                    [attr.aria-expanded]="row.expanded"
                    type="button"
                    (click)="toggleRowClickHandler($event, row.rowId)"
                  >
                    <i
                      class="atn-icon atn-blue atn-ds-table-rows__hierarchy-icon"
                      [class.atn-triangle-down]="row.expanded"
                      [class.atn-triangle-right]="!row.expanded"
                    ></i>
                  </button>
                } @else {
                  <span class="atn-ds-table-rows__hierarchy-placeholder"></span>
                }
              }

              <atn-ds-table-cell-renderer
                #columnContent
                [attr.data-column-id]="cell.columnId"
                [attr.data-content-offset-px]="cell.contentOffsetPx"
                [cell]="cell"
              />
            </div>
          </div>
        </div>
      }

      @if (rowToolsWidthPx && row.tools.length) {
        <atn-ds-table-row-tools
          class="atn-ds-table-rows__tools"
          [tools]="row.tools"
          [style.left.px]="rowToolsOffsetLeftPx"
          [style.width.px]="rowToolsWidthPx"
        />
      }
    </div>
  }
</div>
